import { render, staticRenderFns } from "./ViewBusinessUnit.vue?vue&type=template&id=487d9164&scoped=true"
import script from "./ViewBusinessUnit.vue?vue&type=script&lang=js"
export * from "./ViewBusinessUnit.vue?vue&type=script&lang=js"
import style0 from "./ViewBusinessUnit.vue?vue&type=style&index=0&id=487d9164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d9164",
  null
  
)

export default component.exports